import { Currency } from "./currency.type";

export enum TransactionType {
  CREDIT = "Приход",
  MACHINE = "Станок",
  DEBIT = "Расход",
  INVESTMENT = "Инвестиция",
  WITHDRAWAL = "ВЫВОД",
  CASHTRANSFER = "Конвертация",
  CASHTRANSFER_DEBIT = "Конвертация (Расход)",
}

export enum CreditType {
  CLIENT = "От клиента",
  OTHER = "Прочие",
  INVENTORY = "Инвентарь",
}

export enum ExpenseType {
  OTHER = "Прочее",
  PURCHASE = "Покупка",
  INVENTORY = "Инвентарь",
  AUDIT = "Ревизия",
  SALARY = "Зарплата",
  BONUS = "Премия",
  METER_READING = "Счетчик",
}

export enum TransactionStatus {
  PENDING = "Ожидает",
  COMPLETED = "Выполнено",
  REVIEWED = "Проверен",
}

export interface Transaction {
  transactionId: number;
  _id: string;
  date: string;
  type: TransactionType;
  creditType?: CreditType;
  expenseId?: string;
  expenseType?: ExpenseType | string;
  currency: Currency;
  exchangeRate: number;
  cashboxId: string;
  cashboxName: string;
  cashierName: string;
  cashierId: string;
  amount: number;
  profit: number;
  description: string;
  machineId: string;
  machineName: string;
  balanceBefore: number;
  balanceAfter: number;
  netProfitAfter?: number;
  netProfitBefore?: number;
  status: TransactionStatus;
  salaryDebtBefore?: number;
  salaryDebtAfter?: number;
}
